import React from 'react';
import PropTypes from 'prop-types';

const HelpPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 3c7.167 0 13 5.832 13 13s-5.833 13-13 13C8.832 29 3 23.168 3 16S8.832 3 16 3zm-1 13.005V17.99a1 1 0 1 0 2 0v-1.102a4.508 4.508 0 0 0 3.5-4.388c0-2.481-2.019-4.5-4.5-4.5a4.505 4.505 0 0 0-4.5 4.5 1 1 0 1 0 2 0c0-1.38 1.122-2.5 2.5-2.5s2.5 1.12 2.5 2.5c0 1.379-1.122 2.5-2.5 2.5a1 1 0 0 0-1 1v.005zM16 21c-.831 0-1.5.669-1.5 1.5 0 .83.669 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.831-.669-1.5-1.5-1.5z"
    />
  );
};

HelpPath.propTypes = {
  fill: PropTypes.string,
};

export default HelpPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/help.jsx